import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { companySchema, CompanyFormValues } from "@modules/companies/validations/companySchema";
import { useCreateCompanyMutation } from "@modules/companies/services/mutations";

export function useCompanyCreateForm() {
  const { mutateAsync, isPending } = useCreateCompanyMutation();

  const methods = useForm<CompanyFormValues>({
    resolver: zodResolver(companySchema()),
    defaultValues: {
      order: 0,
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
